import { z } from 'zod';
import { storageSourceSchema } from '@xiltrion/entidad';
/**
 * Respaldos de la base de la suite (Datalog › Respaldos). Siempre queda una copia en el servidor (BACKUP_DIR); el
 * destino remoto es opcional: un almacenamiento ya registrado en alguna entidad o un bucket propio de los respaldos.
 */
/** Bucket propio: la misma forma que un almacenamiento de entidad, sin nombre. Sin `secretAccessKey` se conserva el guardado. */
export const backupS3Schema = storageSourceSchema.omit({ kind: true, name: true });
export const backupDestinationSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('NONE') }),
    z.object({ kind: z.literal('SOURCE'), sourceId: z.string().uuid('Elige un almacenamiento') }),
    z.object({ kind: z.literal('S3'), storage: backupS3Schema }),
]);
const folder = z.string().trim().max(200).regex(/^[A-Za-z0-9._\-/]*$/, 'Carpeta no válida').transform((v) => v.replace(/^\/+|\/+$/g, ''));
export const backupSettingsSchema = z.object({
    enabled: z.boolean(),
    /** Hora del día (Bogotá) en que corre el respaldo programado. */
    hour: z.number().int().min(0).max(23),
    /** Cuántos respaldos guardar en el servidor. */
    localKeep: z.number().int().min(1).max(90),
    /** Cuántos guardar en el destino remoto (no se borra nada en un bucket con bloqueo de objetos). */
    remoteKeep: z.number().int().min(1).max(3650),
    /** Carpeta dentro del bucket (bajo la carpeta del almacenamiento, si la tiene). */
    prefix: folder,
    destination: backupDestinationSchema,
});
export const BACKUP_DEFAULTS = { enabled: false, hour: 2, localKeep: 7, remoteKeep: 30, prefix: 'datalog-suite' };
export const testBackupDestinationSchema = z.object({ destination: backupDestinationSchema.optional() });
//# sourceMappingURL=backups.js.map